// frontend/src/lib/designerSave.js
//
// Endpoint policy for saving from the Designer Portal editor. Designer work is
// stored ONLY in the designer_templates collection — never in user `designs`.
// First save creates a draft; once we hold its id, every save updates the same
// record in place.
export function designerSaveEndpoint({ designerTemplateId } = {}) {
  return designerTemplateId
    ? { method: 'PUT', path: `/api/designer/templates/${designerTemplateId}` }
    : { method: 'POST', path: '/api/designer/templates/draft' };
}
